
























































































































































import { Component, Mixins } from 'vue-property-decorator'
import VhFixMixin from '@/plugins/mixins-vh-fix'
import { Company } from '@/api/model/company'
import { ReferralType, WidgetFlowType } from '@/api/types'
import axios from 'axios'

const basePath = process.env.VUE_APP_KEYVUE_BACKEND_BASEPATH || ''
const baseUrl = process.env.VUE_APP_KEYVUE_BACKEND_BASEURL

enum Score {
    LOW = -1,
    NEUTRAL = 0,
    HIGH = 1,
}

@Component
export default class Appraisal extends Mixins(VhFixMixin) {
    company: Company = null
    companyLoading: boolean = true
    companyError: boolean = false
    submitted: boolean = null
    submitting: boolean = null
    submittingError: boolean = false

    async mounted() {
        await this.loadCompany()
    }

    async loadCompany(): Promise<void> {
        this.companyLoading = true

        try {
            const response = await axios.get(`${baseUrl}${basePath}/companies/` + this.$route.query.company)
            this.company = Company.fromData(response.data)
            if ('companyName' in this.$route.query && this.$route.query.companyName.length) {
                this.company.branding.displayName = this.$route.query.companyName as string
            }
            this.$root.$currentCompany = this.company
        } catch (err) {
            this.companyError = true
        } finally {
            this.companyLoading = false
        }
    }

    get isFormEnabled(): boolean {
        if (!this.company || !this.company.activatedWidgetFlowTypes.includes(WidgetFlowType.VALUATION)) {
            return false
        }

        return true
    }

    answers = {
        request: null,
        firstname: null,
        lastname: null,
        zipcode: null,
        streetnumber: null,
        housetype: null,
        reason: null,
        reasonCustom: null,
        phonenumber: null,
        email: null,
        avg: null,
    }

    get reason() {
        if (this.isReasonCustom) {
            return this.answers.reasonCustom
        } else {
            return this.answers.reason
        }
    }

    get score(): Score {
        switch (this.reason) {
            case 'Ik ga wellicht verkopen (Binnen 3 maanden)':
            case 'Ik ga wellicht verkopen (Binnen 6 maanden)':
                return Score.HIGH

            case 'Ik ben gewoon nieuwsgierig':
            case 'Ik ben benieuwd ivm WOZ waarde':
                return Score.LOW

            case 'Ik ga wellicht verkopen (Binnen 12 maanden)':
            default:
                return Score.NEUTRAL
        }
    }

    async submit(): Promise<void> {
        this.submitted = null
        this.submitting = true
        this.submittingError = false

        try {
            await axios.post(`${baseUrl}${basePath}/referrals/create`, {
                company: this.company.resourceIdentifier,
                source: 'emma',
                newSource: this.company.emmaSource?.resourceIdentifier,
                firstname: this.answers.firstname,
                lastname: this.answers.lastname,
                streetnumber: this.answers.streetnumber,
                zipcode: this.answers.zipcode,
                email: this.answers.email,
                phonenumber: this.answers.phonenumber,
                type: ReferralType.APPRAISAL,
                score: this.score,
                data: {
                    streetnumber: this.answers.streetnumber,
                    zipcode: this.answers.zipcode,
                    housetype: this.answers.housetype,
                    reason: this.reason,
                    tag: this.$route.query.tag || null,
                    utm_source: this.$route.query.utm_source || null,
                    utm_medium: this.$route.query.utm_medium || null,
                    utm_campaign: this.$route.query.utm_campaign || null,
                    utm_term: this.$route.query.utm_term || null,
                    utm_content: this.$route.query.utm_content || null,
                    form_identifier: 'appraisal_appraisal',
                },
            })

            this.submitted = true
        } catch (err) {
            this.submitted = false
            this.submittingError = true
        } finally {
            this.submitting = false
        }
    }

    get validHousetypes() {
        return [
            'Vrijstaande woning',
            '2 onder 1 kap woning',
            'Geschakelde 2 onder 1 kapwoning',
            'Geschakelde woning',
            'Tussen/rijwoning',
            'Hoekwoning',
            'Eindwoning',
            'Galerijflat',
            'Portiekflat',
            'Corridorflat',
            'Maisonnette',
            'Benedenwoning',
            'Bovenwoning',
            'Portiekwoning',
        ].map(housetype => {
            return {
                label: housetype,
                value: housetype,
            }
        })
    }

    get validReasons() {
        return [
            'Ik ga wellicht verkopen (Binnen 3 maanden)',
            'Ik ga wellicht verkopen (Binnen 6 maanden)',
            'Ik ga wellicht verkopen (Binnen 12 maanden)',
            'Ik ben gewoon nieuwsgierig',
            'Ik ben benieuwd ivm WOZ waarde',
            'Anders, namelijk:',
        ].map(reason => {
            return {
                label: reason,
                value: reason,
            }
        })
    }

    get isReasonCustom(): boolean {
        return this.answers.reason === 'Anders, namelijk:'
    }
}
